'use strict';

var $ = require('jquery');
require('jquery-zoom');

var Analytics = require('@plaudit/analytics').Analytics;
var myAnalytics = Analytics.getInstance();

function init() {
	var $galleries = $('.gallery');
	if ($galleries.length === 0) {
		return;
	}

	$galleries.each(function() {
		var $gallery = $(this);

		var $galleryView 	= $gallery.find('.gallery__view');
		var $galleryThumb 	= $gallery.find('.gallery__thumb');

		var removeOldMediaTimeoutID = undefined;
		var removeOldMedia = function() {
			// Remove all but first one
			var $mediaElements = $galleryView.find('.gallery__media');
			for (var i=1; i < $mediaElements.length; i++) {
				var $media = $($mediaElements[i]);
				$media.remove();
			}

			$galleryView.removeClass('loading');

			removeOldMediaTimeoutID = undefined;
		}

		var setupZoomFunctionality = function() {
			if ($gallery.hasClass('gallery--hasZoom')) {
				$galleryView.find('.gallery__media').zoom({ 
					url: $(this).parent().find('img').attr('data-zoom-src'),
					callback: function() {
						$(this).attr('alt', $(this).parent().find('img:first-child').attr('alt'));
					},
					on: 'click',
					onZoomIn: function() {
						$gallery.addClass('gallery--isZoomed');
					},
					onZoomOut: function() {
						$gallery.removeClass('gallery--isZoomed');
					}
				});
			}
		}

		var onGalleryItemClick = function(event) {
			event.preventDefault();

			var $this = $(this);
			var href = $this.attr('href');
			var alt = $this.find('img.rigid').attr('alt');
			alt = typeof alt === 'undefined' ? ' ' : alt;
			var $galleryMedia = $galleryView.find('.gallery__media');

			// if (typeof ga !== 'undefined') {
			// 	ga('send', 'event', 'Gallery', 'Click');
			// }
			myAnalytics.trackEvent("Gallery", "Click");

			if ($galleryMedia.attr('src') != href) {
				if (removeOldMediaTimeoutID !== undefined) {
					clearTimeout(removeOldMediaTimeoutID);
				}
				removeOldMedia();

				// Remove 'active' class from all thumbnails and then add to current
				$galleryThumb.removeClass('active');
				$this.parent().addClass('active');

				// Load the new media
				$galleryView.addClass('loading');

				$galleryView.attr('data-item', $this.parent().index() + 1);

				var strMedia = $this.parent().hasClass('gallery__thumb--video') ? 
					'<iframe class="gallery__media" width="550" height="340" src="'+href+'" frameborder="0" allowfullscreen="1"></iframe>'
					: $this.parent().hasClass('gallery__thumb--model') ?
					'<div class="gallery__media Sirv" data-src="'+href+'"></div>'
					: '<div class="gallery__media"><img src="'+href+'" data-zoom-src="'+$this.attr('data-zoom-src')+'" alt="'+alt+'" /></div>';
				$galleryView.prepend($(strMedia));

				setupZoomFunctionality();

				// Have media removing removed once done
				removeOldMediaTimeoutID = window.setTimeout(removeOldMedia, 1000);
			}
		}

		$galleryThumb.on('click', 'a', onGalleryItemClick);
		setupZoomFunctionality();
	});
}
module.exports = {
	init : init
};
